import {
	KICK_POINT_REDEMPTION_ROUTE_API,
	GET_LIST_KICK_POINT_REDEMPTION,
	GET_DETAIL_KICK_POINT_REDEMPTION,
	ADD_KICK_POINT_REDEMPTION,
	UPDATE_KICK_POINT_REDEMPTION,
	DELETE_KICK_POINT_REDEMPTION,
	NEW_KICK_POINT_REDEMPTION,
	FETCHING_KICK_POINT_REDEMPTION,
	KICK_POINT_REDEMPTION_ERROR
} from '../constants';

import { logout } from './authAction';
import { apiClient } from '../utils/Api';
import { manipulateErrors, checkAuthorized } from '../utils';

/**
 * Get list of kick point redemptions
 * @guards jwt-token
 * @param {object?} query axios config, e.g. { params: { active, page, per_page } }
 */
export const getKickPointRedemptionList = (query) => {
	return dispatch => (
		dispatch(isFetch({ type: 'fetch', status: true })),
		apiClient().get(KICK_POINT_REDEMPTION_ROUTE_API, query)
		.then(res => {
			dispatch(onSuccess(res.data, GET_LIST_KICK_POINT_REDEMPTION))
			dispatch(isFetch({ type: 'fetch', status: false }))
		})
		.catch(err => {
			dispatch(onError(err));
			dispatch(isFetch({ type: 'fetch', status: false }));
		})
	)
}

/**
 * Get detail of a kick point redemption
 * @guards jwt-token
 * @param {integer} id
 */
export const getDetailKickPointRedemption = (id) => {
	return dispatch => (
		dispatch(isFetch({ type: 'fetch', status: true })),
		apiClient().get(`${KICK_POINT_REDEMPTION_ROUTE_API}/${id}`)
		.then(res => {
			dispatch(onSuccess(res.data, GET_DETAIL_KICK_POINT_REDEMPTION))
			dispatch(isFetch({ type: 'fetch', status: false }))
		})
		.catch(err => {
			dispatch(onError(err));
			dispatch(isFetch({ type: 'fetch', status: false }));
		})
	)
}

export const saveKickPointRedemption = (payload, id) => {
	return dispatch => {
		if (id === undefined || id === null)
			dispatch(createKickPointRedemption(payload));
		else
			dispatch(updateKickPointRedemption(id, payload));
	}
}

export const createKickPointRedemption = (payload) => {
	return dispatch => (
		dispatch(isFetch({ type: 'submit', status: true })),
		apiClient().post(`${KICK_POINT_REDEMPTION_ROUTE_API}`, payload)
		.then(res => {
			dispatch(onSuccess(res.data, ADD_KICK_POINT_REDEMPTION))
			dispatch(isFetch({ type: 'submit', status: false }))
		})
		.catch(err => {
			dispatch(onError(err));
			dispatch(isFetch({ type: 'submit', status: false }));
		})
	)
}

export const updateKickPointRedemption = (id, payload) => {
	return dispatch => (
		dispatch(isFetch({ type: 'submit', status: true })),
		apiClient().put(`${KICK_POINT_REDEMPTION_ROUTE_API}/${id}`, payload)
		.then(res => {
			dispatch(onSuccess(res.data, UPDATE_KICK_POINT_REDEMPTION))
			dispatch(isFetch({ type: 'submit', status: false }))
		})
		.catch(err => {
			dispatch(onError(err, id));
			dispatch(isFetch({ type: 'submit', status: false }));
		})
	)
}

export const deleteKickPointRedemption = (id) => {
	return dispatch => (
		dispatch(isFetch({ type: 'submit', status: true })),
		apiClient().delete(`${KICK_POINT_REDEMPTION_ROUTE_API}/${id}`)
		.then(res => {
			dispatch(onSuccess(res.data, DELETE_KICK_POINT_REDEMPTION))
			dispatch(isFetch({ type: 'submit', status: false }))
		})
		.catch(err => {
			dispatch(onError(err, id));
			dispatch(isFetch({ type: 'submit', status: false }));
		})
	)
}

export const newKickPointRedemption = () => {
	return {
		type: NEW_KICK_POINT_REDEMPTION
	}
}

/**
 * Indicates when start fetch api or end fetch api
 * @param {object} payload
 */
export const isFetch = (payload) => (
	{
		type: FETCHING_KICK_POINT_REDEMPTION,
		payload: payload
	}
)

/**
 * When onSuccess triggered
 * @param {object} res
 * @param {string} type
 */
export const onSuccess = (res, type) => (
	{
		type: type,
		payload: res
	}
)

/**
 * When error fetch or connect to api
 * @param {object} err
 */
export const onError = (err, id, type = KICK_POINT_REDEMPTION_ERROR) => {
	if (!checkAuthorized(manipulateErrors(err)))
		return logout();
	return {
		type: type,
		payload: { ...manipulateErrors(err), id }
	}
}
